module.exports = __webpack_public_path__ + "static/media/LightfootCANEvent07.19.1aa5185e.jpg";